<template>
  <div class="grow">
    <div class="st-window">
      <div class="header">
        <span class="text">{{ $t('stranger.walkman.title') }}</span>
        <div class="close-button">
          <button class="st-button" @click="close()">X</button>
        </div>
      </div>
      <div class="content st-scrollbar">
        <div class="st-wm-container">
         <img class="st-wm-bg" src="/stranger/assets/images/ST_WALKMAN_BG.png" />
         <img class="st-top-buttons" src="/stranger/assets/images/ST_WALKMAN_BUTTONS.png" />
         <img class="st-fm-button st-button-left" @click="fmLeft()" src="/stranger/assets/images/ST_WALKMAN_FM_LEFT.png" />
         <img class="st-fm-button st-button-right" @click="fmRight()" src="/stranger/assets/images/ST_WALKMAN_FM_RIGHT.png" />
         <img class="st-fm-cursor" v-bind:style="{ left: cursorPosition }" src="/stranger/assets/images/ST_WALKMAN_FM_CURSOR.png" />         
         <img class="st-wheel st-wheel-1" v-bind:class="wheelClass" src="/stranger/assets/images/ST_WALKMAN_WHEEL.png" />
         <img class="st-wheel st-wheel-2" v-bind:class="wheelClass" src="/stranger/assets/images/ST_WALKMAN_WHEEL.png" />
         <img class="st-cst-button st-button-back" @click="k7Back()" src="/stranger/assets/images/ST_WALKMAN_CASSETTE_BACK.png" />
         <img class="st-cst-button st-button-play" @click="k7Play()" src="/stranger/assets/images/ST_WALKMAN_CASSETTE_PLAY.png" />
         <img class="st-cst-button st-button-pause" @click="k7Pause()" src="/stranger/assets/images/ST_WALKMAN_CASSETTE_PAUSE.png" />
         <div class="st-fm-freq">{{ frequency | freq }}</div>
        </div>
      </div>
    </div>
    <Sound src="/stranger/assets/audio/click.mp3" ref="clickSound" />
    <Sound src="/stranger/assets/audio/radio_static.mp3" volume="0.6" loop ref="staticSound" />
    <Sound src="/stranger/assets/audio/k7_rewind.mp3" ref="rewindSound" />
    <Sound :src="`/stranger/assets/audio/${currentLocale}/radio_wsqk.mp3`" @onEnd="k7Pause()" ref="wsqkSound" />

    <Sound src="/stranger/assets/audio/radio_synthwave_opt.mp3" loop ref="synthwaveMusic" />
    <Sound src="/stranger/assets/audio/radio_synthwave2_opt.mp3" loop ref="synthwave2Music" />
    <Sound src="/stranger/assets/audio/radio_synthwave3_opt.mp3" loop ref="synthwave3Music" />
    <Sound :src="`/stranger/assets/audio/${currentLocale}/radio_pirate.mp3`" ref="pirateMusic" />
  </div>
</template>
  
<script>
  import currentGameMixin from "@/mixins/currentGameMixin";
  import Sound from "@/components/stranger/Sound";

  export default {
    name: "Walkman",

    components: {
      Sound,
    },

    mixins: [currentGameMixin],

    data: () => ({
      oldFrequency: 87.5,
      frequency: 87.5,
      state: 'pause',
    }),

    methods: {
      stopMusic() {
        this.$strangerStore.walkman.stations.forEach(s => { 
          this.$refs[s.name + 'Music'].stop();    
        });
      },
      refreshRadio() {
        this.stopMusic();

        const radio = this.$strangerStore.walkman.stations.find(s => s.frequency.toFixed(1) === this.frequency.toFixed(1));

        if (radio) {
          if (radio.name === 'pirate' && !this.$strangerStore.getEnvelope('D').solved)
            return

          this.$refs.staticSound.stop();
          this.$refs[radio.name + 'Music'].stop();
          this.$refs[radio.name + 'Music'].play();
        }
      },
      clickSound() {
        this.$refs.clickSound.stop();
        this.$refs.clickSound.play();
      },
      close() {
        this.$router.push({ name: 'stranger-home' });
      },
      fmLeft: function() {
        this.frequency -= .2;
        if (this.frequency < 87.5) this.frequency = 87.5;

        this.$strangerStore.walkman.currentRadio = this.frequency;
        this.$strangerStore.saveState();

        this.clickSound();

        this.$refs.staticSound.play();
        this.$refs.rewindSound.stop();
        this.$refs.wsqkSound.pause();

        this.refreshRadio();

        this.state = 'fm';
      },
      fmRight: function() {
        this.frequency += .2;
        if (this.frequency > 107.9) this.frequency = 107.9;

        this.$strangerStore.walkman.currentRadio = this.frequency;
        this.$strangerStore.saveState();

        this.clickSound();

        this.$refs.staticSound.play();
        this.$refs.rewindSound.stop();
        this.$refs.wsqkSound.pause();  

        this.refreshRadio();
        
        this.state = 'fm';        
      },
      k7Back: function() {
        this.clickSound();
        this.stopMusic();

        this.$refs.staticSound.stop();
        this.state = 'back';        
        this.$refs.rewindSound.play();
        this.$refs.wsqkSound.stop();     
        setTimeout(() => {
          this.$refs.rewindSound.stop();
          this.state = 'pause';
        }, 2800);
      },
      k7Play: function() {
        this.clickSound();
        this.stopMusic();        

        this.$refs.staticSound.stop();
        this.$refs.rewindSound.stop();
        this.$refs.wsqkSound.play();        
        this.state = 'play';        
      },  
      k7Pause: function() {
        this.clickSound();
        this.stopMusic();

        this.$refs.staticSound.stop();
        this.$refs.rewindSound.stop();
        this.$refs.wsqkSound.pause();         
        this.state = 'pause';
      }        
    },

    watch: {

    },

    computed: { 
      cursorPosition: function() {
        const startFreq = 87.5;
        const endFreq = 107.9;
        const startPos = 44;
        const endPos = 203;        
        let f = this.frequency;

        const ratio = (f - startFreq) / (endFreq - startFreq);
        const pos = startPos + (endPos - startPos) * ratio;

        return pos.toString() + "px";       
      },
      wheelClass: function() {
        switch (this.state) {
          case 'pause':
          case 'fm':
          default:
            return '';
          case 'play':
            return 'rotating';
          case 'back':
            return 'rotating-bw';
        }
      }
    },

    async mounted() { 
      this.frequency = this.$strangerStore.walkman.currentRadio;
    }
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/css/stranger.scss';

  .st-window {
    .content {
      max-height: 400px;

      .st-wm-container {
        margin: auto;
        width: 300px;
        position: relative;

        img.st-wm-bg {
          max-width: 300px;
          margin-top: 8px;
        }

        img.st-wheel {
          position: absolute;
          top: 128px;
          left: 120px;
          max-width: 40px;

          &.st-wheel-2 {
            left: 200px;
          }
        }

        img.st-top-buttons {
          max-width: 70px;
          position: absolute;
          top: 0px;
          left: 200px;
        }

        img.st-cst-button {
          max-width: 35px;
          position: absolute;
          top: 189px;
          left: 100px;
          border-bottom: 4px solid #000;     
          cursor: pointer; 

          &.st-button-play {
            left: 140px;
          }

          &.st-button-pause {
            left: 180px;
          } 
          
          &:active {
            top: 191px;
            border-bottom: 2px solid #000;
          }
        }

        img.st-fm-cursor {
          max-width: 10px;
          position: absolute;
          top: 41px;
          left: 50px;
        }

        div.st-fm-freq {
          max-width: 10px;
          position: absolute;
          top: 18px;
          left: 124px; 
          color: #fff;
          font-family: Amiga4ever;         
        }

        img.st-fm-button {
          max-width: 35px;
          position: absolute;
          top: 25px;
          left: 220px;
          border-bottom: 4px solid #000;     
          cursor: pointer; 
          touch-action: manipulation;

          &.st-button-right {
            left: 260px;
          }

          &:active {
            top: 27px;
            border-bottom: 2px solid #000;
          }
        }        
      }
    }
  }

  @keyframes rotating {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
  .rotating {
    animation: rotating 2s linear infinite;
  }

@keyframes rotating-bw {
    from {
      transform: rotate(360deg);
    }
    to {
      transform: rotate(0deg);
    }
  }
  .rotating-bw {
    animation: rotating-bw 0.5s linear infinite;
  }    
</style>
  